import { useCallback } from "react";

type UseAnchorOptions = {
  offset?: number;
  behavior?: ScrollBehavior;
};

export function useAnchor(options: UseAnchorOptions = {}) {
  const {
    offset = 0,
    behavior = "smooth",
  } = options;

  const scrollToAnchor = useCallback(
    (id: string) => {
      const element = document.getElementById(id);

      if (!element) return;

      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: elementPosition,
        behavior,
      });
    },
    [offset, behavior]
  );

  return { scrollToAnchor };
}